import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import {Flex, Box} from 'reflexbox';
import {inject, observer} from 'mobx-react';
import {Card, CardTitle, CardText, Slider} from 'react-md';

@withRouter
export class RegisterSuccessCard extends Component {
    constructor(props) {
        super(props)
        this.positionImg = {
            MB: require('assets/img/bagdes/cci_mb.png'),
            DIS: require('assets/img/bagdes/cci_dis.png'),
            PRO: require('assets/img/bagdes/cci_pro.png'),
            VIP: require('assets/img/bagdes/cci_vip.png'),
        }

        this.honorImg = {
            PE: require('assets/img/bagdes/Platinum.jpg'),
            SE: require('assets/img/bagdes/Sapphire.jpg'),
            EE: require('assets/img/bagdes/Emerald.jpg'),
            DE: require('assets/img/bagdes/Diamond.png'),
            CE: require('assets/img/bagdes/Crown.png'),
        }

    }

    componentDidMount() {

    }

    renderMember() {
        window.matchMedia('(min-width: 700px)');
        var picUrl;
        const {member} = this.props;
        if (member.honor) {
            picUrl = this.honorImg[member.honor];
        } else {
            picUrl = this.positionImg[member.level];
        }

        let imtPath;
        if (picUrl) {
            imtPath = (
                <Flex className='member-pos' w={4 / 10} justify='center'>
                    <img src={picUrl}/>
                </Flex>
            );
        }

        return (
            <Flex className='member-register-info'>
                {imtPath}
                <Flex w={6 / 10}>
                    <Flex column justify='center'>
                        <div>
                            <h3>ชื่อ : {member.name_t}</h3>
                        </div>
                        <div>
                            <h4>รหัสสมาชิก : {member.mcode || '-'}</h4>
                        </div>
                    </Flex>

                </Flex>
            </Flex>
        )
    }

    render() {
        let cardTitle = 'ลงทะเบียนสำเร็จ';
        let footer = null;
        if (this.props.result.code === 10) {
            cardTitle = 'ลงทะเบียนซ้ำ';

        } else {
            footer = (
                <Flex column style={{textAlign: 'center'}}>
                {/*<span>กรุณาแสดงข้อความนี้ต่อเจ้าหน้าที่เพิ่อรับของสมนาคุณ</span>*/}
            </Flex>)
        }


        return (
            <Card className='reg-card  md-block-centered'>
                <CardTitle title={cardTitle}/>
                <CardText>
                    <Flex column>
                        {this.renderMember()}
                    </Flex>
                    {footer}
                </CardText>
            </Card>

        );
    }
}

export default RegisterSuccessCard;



// WEBPACK FOOTER //
// ./src/component/event/RegisterSuccessCard.jsx